import { Pipe, PipeTransform } from '@angular/core';
import { FormatDecimalTimePipe } from '@ui-kit/pipes/format-decimal-time.pipe';
import { SecondsToPeriodPipe } from '@ui-kit/pipes/secondsToPeriod.pipe';

@Pipe({ name: 'periodSelect', pure: true })
export class PeriodSelectPipe implements PipeTransform {
  transform(value, settings) {
    if (settings) {
      const decimalPeriod = new FormatDecimalTimePipe();
      return decimalPeriod.transform(value);
    } else {
      const minutesPeriod = new SecondsToPeriodPipe();
      return minutesPeriod.transform(value);
    }
  }
}
